{
  "PROFILE_SETTINGS": {
    "LINK": "Profile Settings",
    "TITLE": "Profile Settings",
    "BTN_TEXT": "Update Profile",
    "DELETE_AVATAR": "Delete Avatar",
    "AVATAR_DELETE_SUCCESS": "Avatar has been deleted successfully",
    "AVATAR_DELETE_FAILED": "There is an error while deleting avatar, please try again",
    "UPDATE_SUCCESS": "Your profile has been updated successfully",
    "PASSWORD_UPDATE_SUCCESS": "Your password has been changed successfully",
    "AFTER_EMAIL_CHANGED": "Your profile has been updated successfully, please login again as your login credentials are changed",
    "FORM": {
      "PICTURE": "Profile Picture",
      "EMAIL_SIGNATURE_PICTURE": {
        "LABEL": "Fotografia e nënshkrimit të email-it",
        "HINT": "Përdoret në nënshkrimet e email-it. {'{{'}email_signature_picture{'}}'} zëvendësohet me URL-në e kësaj fotoje (jo me një etiketë imazhi) — përdoreni si burim imazhi (atributi src i një etikete img) në nënshkrimin tuaj ose në nënshkrimin e kutisë postare. Nëse nuk është caktuar, nuk futet asgjë.",
        "DELETE_SUCCESS": "Fotografia e nënshkrimit të email-it u fshi me sukses",
        "DELETE_FAILED": "Ndodhi një gabim gjatë fshirjes së fotografisë së nënshkrimit të email-it, ju lutemi provoni përsëri"
      },
      "AVATAR": "Profile Image",
      "ERROR": "Please fix form errors",
      "REMOVE_IMAGE": "Remove",
      "UPLOAD_IMAGE": "Upload image",
      "UPDATE_IMAGE": "Update image",
      "PROFILE_SECTION": {
        "TITLE": "Profile",
        "NOTE": "Your email address is your identity and is used to log in."
      },
      "SEND_MESSAGE": {
        "TITLE": "Hotkey to send messages",
        "NOTE": "You can select a hotkey (either Enter or Cmd/Ctrl+Enter) based on your preference of writing.",
        "UPDATE_SUCCESS": "Your settings have been updated successfully",
        "CARD": {
          "ENTER_KEY": {
            "HEADING": "Enter (↵)",
            "CONTENT": "Send messages by pressing Enter key instead of clicking the send button."
          },
          "CMD_ENTER_KEY": {
            "HEADING": "Cmd/Ctrl + Enter (⌘ + ↵)",
            "CONTENT": "Send messages by pressing Cmd/Ctrl + enter key instead of clicking the send button."
          }
        }
      },
      "INTERFACE_SECTION": {
        "TITLE": "Interface",
        "NOTE": "Personalizoni pamjen e panelit tuaj.",
        "FONT_SIZE": {
          "TITLE": "Font size",
          "NOTE": "Adjust the text size across the dashboard based on your preference.",
          "UPDATE_SUCCESS": "Your font settings have been updated successfully",
          "UPDATE_ERROR": "There is an error while updating the font settings, please try again",
          "OPTIONS": {
            "SMALLER": "Smaller",
            "SMALL": "Small",
            "DEFAULT": "Default",
            "LARGE": "Large",
            "LARGER": "Larger",
            "EXTRA_LARGE": "Extra Large"
          }
        },
        "UI_LANGUAGE": {
          "TITLE": "Gjuha e panelit",
          "NOTE": "Anulo gjuhën e llogarisë për panelin tuaj. Lëreni bosh për të përdorur gjuhën e parazgjedhur të llogarisë.",
          "USE_ACCOUNT_DEFAULT": "Përdor parazgjedhjen e llogarisë",
          "API_SUCCESS": "Gjuha e panelit tuaj u përditësua me sukses"
        },
        "MESSAGE_TRANSLATION": {
          "TITLE": "Gjuha e mesazhit",
          "NOTE": "Zgjidhni nëse doni të shfaqen mesazhet origjinale apo përkthimet e tyre",
          "ORIGINAL": "Origjinal",
          "TRANSLATED": "Përkthyer"
        },
        "PASTE_BEHAVIOR": {
          "TITLE": "Sjellja e ngjitjes",
          "NOTE": "Zgjidhni si duhet të përpunohet përmbajtja e ngjitur kur shkruani mesazhe",
          "UPDATE_SUCCESS": "Cilësimet tuaja të ngjitjes u përditësuan me sukses",
          "OPTIONS": {
            "PRESERVE_ALL": {
              "HEADING": "Ruaj të gjithë formatimin",
              "DESCRIPTION": "Ruaj të gjithë formatimin, përfshirë tabelat, stilet dhe elemente të tjera HTML kur ngjitni përmbajtje."
            },
            "TEXT_WITH_LINKS": {
              "HEADING": "Vetëm tekst me lidhje",
              "DESCRIPTION": "Konverto në tekst të thjeshtë por ruaj lidhjet e klikueshme kur ngjitni përmbajtje."
            },
            "PLAIN_TEXT_ONLY": {
              "HEADING": "Vetëm tekst i thjeshtë",
              "DESCRIPTION": "Hiq të gjithë formatimin dhe konverto në tekst të thjeshtë kur ngjitni përmbajtje."
            }
          }
        },
        "REPLY_BOX_HEIGHT": {
          "TITLE": "Lartësia e kutisë së përgjigjes",
          "NOTE": "Vendosni lartësinë minimale të kutisë së përgjigjes si përqindje e lartësisë së ekranit. Vlen vetëm për bisedat me email.",
          "UPDATE_SUCCESS": "Cilësimi i lartësisë së kutisë së përgjigjes u përditësua me sukses",
          "PERCENT_LABEL": "Lartësia (% e lartësisë së ekranit)",
          "OPTIONS": {
            "DEFAULT": {
              "HEADING": "Parazgjedhur",
              "DESCRIPTION": "Kutia e përgjigjes fillon e vogël dhe rritet ndërsa shkruani."
            },
            "CUSTOM": {
              "HEADING": "E personalizuar",
              "DESCRIPTION": "Kutia e përgjigjes ka gjithmonë të paktën përqindjen e zgjedhur të lartësisë së ekranit."
            }
          }
        }
      },
      "AUTO_NAVIGATION": {
        "TITLE": "Kalo automatikisht te biseda tjetër",
        "NOTE": "Kalon automatikisht te biseda tjetër e hapur pasi zgjidhet biseda aktuale",
        "UPDATE_SUCCESS": "Cilësimi i kalimit automatik u përditësua me sukses"
      },
      "MESSAGE_SIGNATURE_SECTION": {
        "TITLE": "Personal message signature",
        "DESCRIPTION": "Krijoni një nënshkrim unik mesazhi që të shfaqet në fund të çdo email-i që dërgoni. Mund të përfshini edhe një figurë brenda tekstit.",
        "NOTE": "Create a unique message signature to appear at the end of every message you send from any inbox. You can also include an inline image, which is supported in live-chat, email, and API inboxes.",
        "BTN_TEXT": "Save message signature",
        "API_ERROR": "Couldn't save signature! Try again",
        "API_SUCCESS": "Signature saved successfully",
        "IMAGE_UPLOAD_ERROR": "Couldn't upload image! Try again",
        "IMAGE_UPLOAD_SUCCESS": "Image added successfully. Please click on save to save the signature",
        "IMAGE_UPLOAD_SIZE_ERROR": "Image size should be less than {size}MB"
      },
      "MESSAGE_SIGNATURE": {
        "LABEL": "Message Signature",
        "ERROR": "Message Signature cannot be empty",
        "PLACEHOLDER": "Insert your personal message signature here."
      },
      "PASSWORD_SECTION": {
        "TITLE": "Password",
        "NOTE": "Updating your password would reset your logins in multiple devices.",
        "BTN_TEXT": "Change password"
      },
      "ACCESS_TOKEN": {
        "TITLE": "Access Token",
        "NOTE": "This token can be used if you are building an API based integration",
        "COPY": "Copy",
        "REGENERATE": "Rigjenero",
        "REGENERATE_SUCCESS": "Token-i i qasjes u rigjenerua me sukses. Përditësoni çdo integrim që përdor token-in e vjetër.",
        "REGENERATE_CONFIRM_TITLE": "Të rigjenerohet token-i i qasjes?",
        "REGENERATE_CONFIRM_MESSAGE": "Kjo do ta pavlefshmërojë token-in aktual. Çdo integrim që përdor token-in e vjetër do të ndalojë së punuari."
      },
      "CHROME_EXTENSION": {
        "TITLE": "Shtesa e Chrome-it",
        "NOTE": "Instaloni shtesën tonë të Chrome-it për të marrë njoftime të detajuara për thirrjet telefonike hyrëse.",
        "INSTALL_BUTTON": "Instalo shtesën",
        "ALREADY_INSTALLED": "Shtesa u instalua"
      },
      "AUDIO_NOTIFICATIONS_SECTION": {
        "TITLE": "Audio Alerts",
        "NOTE": "Enable audio alerts in dashboard for new messages and conversations.",
        "PLAY": "Play sound",
        "ALERT_TYPES": {
          "NONE": "None",
          "MINE": "Assigned",
          "ALL": "All",
          "ASSIGNED": "My assigned conversations",
          "UNASSIGNED": "Unassigned conversations",
          "NOTME": "Open conversations assigned to others"
        },
        "ALERT_COMBINATIONS": {
          "NONE": "You haven't selected any options, you won't receive any audio alerts.",
          "ASSIGNED": "You'll receive alerts for conversations assigned to you.",
          "UNASSIGNED": "You'll receive alerts for any unassigned conversations.",
          "NOTME": "You'll receive alerts for conversations assigned to others.",
          "ASSIGNED+UNASSIGNED": "You'll receive alerts for your assigned conversations and any unattended ones.",
          "ASSIGNED+NOTME": "You'll receive alerts for conversations assigned to you and to others, but not for unassigned ones.",
          "NOTME+UNASSIGNED": "You'll receive alerts for unattended conversations and those assigned to others.",
          "ASSIGNED+NOTME+UNASSIGNED": "You'll receive alerts for all conversations."
        },
        "ALERT_TYPE": {
          "TITLE": "Alert events for conversations",
          "NONE": "None",
          "ASSIGNED": "Assigned Conversations",
          "ALL_CONVERSATIONS": "All Conversations"
        },
        "DEFAULT_TONE": {
          "TITLE": "Alert tone:"
        },
        "CONDITIONS": {
          "TITLE": "Alert conditions:",
          "CONDITION_ONE": "Send audio alerts only if the browser window is not active",
          "CONDITION_TWO": "Send alerts every 10s until all the assigned conversations are read"
        },
        "SOUND_PERMISSION_ERROR": "Autoplay is disabled in your browser. To hear alerts automatically, enable sound permission in your browser settings or interact with the page.",
        "READ_MORE": "Read more"
      },
      "EMAIL_NOTIFICATIONS_SECTION": {
        "TITLE": "Email Notifications",
        "NOTE": "Update your email notification preferences here",
        "CONVERSATION_ASSIGNMENT": "Send email notifications when a conversation is assigned to me",
        "CONVERSATION_CREATION": "Send email notifications when a new conversation is created",
        "CONVERSATION_MENTION": "Send email notifications when you are mentioned in a conversation",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Send email notifications when a new message is created in an assigned conversation",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Send email notifications when a new message is created in a participating conversation",
        "SLA_MISSED_FIRST_RESPONSE": "Send email notifications when a conversation misses first response SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Send email notifications when a conversation misses next response SLA",
        "SLA_MISSED_RESOLUTION": "Send email notifications when a conversation misses resolution SLA"
      },
      "NOTIFICATIONS": {
        "TITLE": "Notification preferences",
        "TYPE_TITLE": "Notification type",
        "EMAIL": "Email",
        "PUSH": "Push notification",
        "TYPES": {
          "CONVERSATION_CREATED": "A new conversation is created",
          "CONVERSATION_ASSIGNED": "A conversation is assigned to you",
          "CONVERSATION_MENTION": "You are mentioned in a conversation",
          "ASSIGNED_CONVERSATION_NEW_MESSAGE": "A new message is created in an assigned conversation",
          "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "A new message is created in a participating conversation",
          "UNASSIGNED_CONVERSATION_NEW_MESSAGE": "Krijohet një mesazh i ri në një bisedë pa agjent të disponueshëm",
          "SLA_MISSED_FIRST_RESPONSE": "A conversation misses first response SLA",
          "SLA_MISSED_NEXT_RESPONSE": "A conversation misses next response SLA",
          "SLA_MISSED_RESOLUTION": "A conversation misses resolution SLA"
        },
        "BROWSER_PERMISSION": "Enable push notifications for your browser so you’re able to receive them",
        "ALLOW_NOTIFICATION_DURING_CALL": "Lejo njoftimet push gjatë një telefonate",
        "TEST_PUSH": "Testo",
        "TESTING": "Duke testuar...",
        "TEST_PUSH_DESCRIPTION": "Dërgoni njoftime testuese për të verifikuar konfigurimin tuaj",
        "TEST_NOTIFICATION_ERROR": "Dërgimi i njoftimit testues dështoi. Provoni përsëri.",
        "TEST_LOCAL_TITLE": "Njoftim testues (lokal)",
        "TEST_LOCAL_BODY": "Ky është një njoftim lokal i shfletuesit. Nëse e shihni këtë, njoftimet e shfletuesit funksionojnë!"
      },
      "API": {
        "UPDATE_SUCCESS": "Your notification preferences are updated successfully",
        "UPDATE_ERROR": "There is an error while updating the preferences, please try again"
      },
      "PUSH_NOTIFICATIONS_SECTION": {
        "TITLE": "Push Notifications",
        "NOTE": "Update your push notification preferences here",
        "CONVERSATION_ASSIGNMENT": "Send push notifications when a conversation is assigned to me",
        "CONVERSATION_CREATION": "Send push notifications when a new conversation is created",
        "CONVERSATION_MENTION": "Send push notifications when you are mentioned in a conversation",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Send push notifications when a new message is created in an assigned conversation",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Send push notifications when a new message is created in a participating conversation",
        "HAS_ENABLED_PUSH": "You have enabled push for this browser.",
        "REQUEST_PUSH": "Enable push notifications",
        "SLA_MISSED_FIRST_RESPONSE": "Send push notifications when a conversation misses first response SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Send push notifications when a conversation misses next response SLA",
        "SLA_MISSED_RESOLUTION": "Send push notifications when a conversation misses resolution SLA"
      },
      "PROFILE_IMAGE": {
        "LABEL": "Profile Image"
      },
      "NAME": {
        "LABEL": "Your full name",
        "ERROR": "Please enter a valid full name",
        "PLACEHOLDER": "Please enter your full name"
      },
      "DISPLAY_NAME": {
        "LABEL": "Display name",
        "ERROR": "Please enter a valid display name",
        "PLACEHOLDER": "Please enter a display name, this would be displayed in conversations"
      },
      "POSITION": {
        "LABEL": "Pozicioni",
        "ERROR": "Vendosni një pozicion të vlefshëm",
        "PLACEHOLDER": "Vendosni pozicionin tuaj"
      },
      "CUSTOM_LINE": {
        "LABEL": "Rreshti i personalizuar",
        "ERROR": "Vendosni një rresht të personalizuar të vlefshëm",
        "PLACEHOLDER": "Vendosni rreshtin tuaj të personalizuar"
      },
      "AVAILABILITY": {
        "LABEL": "Availability",
        "STATUS": {
          "ONLINE": "Online",
          "BUSY": "Busy",
          "OFFLINE": "Offline"
        },
        "SET_AVAILABILITY_SUCCESS": "Availability has been set successfully",
        "SET_AVAILABILITY_ERROR": "Couldn't set availability, please try again"
      },
      "EMAIL_PREVIEW_FORMAT": {
        "TITLE": "Formati i parapamjes së email-it në listën e bisedave",
        "NOTE": "Zgjidhni çfarë shfaqet në listën e bisedave për bisedat nga kutitë hyrëse të email-it",
        "SUBJECT": "Subjekti",
        "SUBJECT_WITH_NOTE": "Subjekti dhe mesazhi i fundit nëse është shënim i brendshëm",
        "UPDATE_SUCCESS": "Cilësimi i parapamjes së email-it u përditësua me sukses"
      },
      "DISABLE_SHORTCUTS": {
        "TITLE": "Çaktivizo shkurtoret e tastierës",
        "NOTE": "Fik të gjitha shkurtoret e tastierës në të gjithë aplikacionin",
        "UPDATE_SUCCESS": "Cilësimi i shkurtoreve të tastierës u përditësua me sukses"
      },
      "FOLDER_ORDER": {
        "TITLE": "Rendi i dosjeve",
        "NOTE": "Personalizoni rendin në të cilin dosjet (pamjet e personalizuara) shfaqen në shiritin anësor. Tërhiqni dhe lëshoni për të ndryshuar rendin.",
        "NO_FOLDERS": "Nuk u gjetën dosje të personalizuara. Krijoni dosje për të organizuar bisedat tuaja."
      },
      "SIDEBAR_CONFIGURATION": {
        "TITLE": "Konfigurimi i shiritit anësor",
        "NOTE": "Personalizoni cilat seksione shfaqen në shiritin anësor të bisedave.",
        "SAVE_BUTTON": "Ruaj konfigurimin",
        "UPDATE_SUCCESS": "Konfigurimi i shiritit anësor u përditësua me sukses",
        "UPDATE_ERROR": "Ndodhi një gabim gjatë përditësimit të konfigurimit të shiritit anësor, provoni përsëri",
        "OPTIONS": {
          "ALL_CONVERSATIONS": "Të gjitha bisedat",
          "ALL_CONVERSATIONS_DESC": "Shfaq elementin e menusë Të gjitha bisedat në shiritin anësor",
          "INBOX": "Kutia hyrëse",
          "INBOX_DESC": "Shfaq kutinë hyrëse kryesore me njoftimet e palexuara",
          "CONVERSATION_GROUPS": "Përmendjet dhe të paadresuarat",
          "CONVERSATION_GROUPS_DESC": "Shfaq grupet e bisedave Përmendjet dhe Të paadresuarat",
          "FOLDERS": "Dosjet",
          "FOLDERS_DESC": "Shfaq pamjet e personalizuara (dosjet) për biseda të organizuara",
          "TEAMS": "Ekipet",
          "TEAMS_DESC": "Shfaq bisedat e filtruara sipas caktimit të ekipeve",
          "CHANNELS": "Kutitë hyrëse",
          "CHANNELS_DESC": "Shfaq bisedat e filtruara sipas kutisë hyrëse",
          "LABELS": "Etiketat",
          "LABELS_DESC": "Shfaq bisedat e filtruara sipas etiketave"
        }
      },
      "PHONE_SETTINGS": {
        "TITLE": "Cilësimet e telefonit",
        "NOTE": "Vendosni kredencialet e hyrjes për sistemin tuaj PBX.",
        "USERNAME": "Emri i përdoruesit",
        "PASSWORD": "Fjalëkalimi",
        "SUBMIT": "Ruaj",
        "USERNAME_INVALID": "Emri i përdoruesit mund të përmbajë vetëm shkronja, shifra dhe . _ - + — pa hapësira dhe pa adresë email-i.",
        "API": {
          "USERNAME_INVALID": "Emri i përdoruesit nuk është një emër i vlefshëm përdoruesi SIP. Përdorni vetëm shkronja, shifra dhe . _ - + — pa hapësira dhe pa adresë email-i.",
          "USERNAME_TAKEN": "Ky emër përdoruesi përdoret tashmë nga një agjent tjetër në këtë llogari."
        }
      },
      "EMAIL": {
        "LABEL": "Your email address",
        "ERROR": "Please enter a valid email address",
        "PLACEHOLDER": "Please enter your email address, this would be displayed in conversations"
      },
      "CURRENT_PASSWORD": {
        "LABEL": "Current password",
        "ERROR": "Please enter the current password",
        "PLACEHOLDER": "Please enter the current password"
      },
      "PASSWORD": {
        "LABEL": "New password",
        "ERROR": "Please enter a password of length 6 or more",
        "PLACEHOLDER": "Please enter a new password"
      },
      "PASSWORD_CONFIRMATION": {
        "LABEL": "Confirm new password",
        "ERROR": "Confirm password should match the password",
        "PLACEHOLDER": "Please re-enter your new password"
      }
    }
  },
  "SIDEBAR_ITEMS": {
    "CHANGE_AVAILABILITY_STATUS": "Change",
    "CHANGE_ACCOUNTS": "Switch account",
    "SWITCH_ACCOUNT": "Switch account",
    "CONTACT_SUPPORT": "Contact support",
    "REPORT_BUG": "Raporto një defekt",
    "SELECTOR_SUBTITLE": "Select an account from the following list",
    "PROFILE_SETTINGS": "Profile settings",
    "KEYBOARD_SHORTCUTS": "Keyboard shortcuts",
    "APPEARANCE": "Change appearance",
    "SUPER_ADMIN_CONSOLE": "SuperAdmin console",
    "DOCS": "Read documentation",
    "LOGOUT": "Log out"
  },
  "BUG_REPORT": {
    "TITLE": "Raporto një defekt",
    "DESCRIPTION_LABEL": "Përshkrimi i problemit",
    "DESCRIPTION_PLACEHOLDER": "Përshkruani problemin që hasët...",
    "SUBMIT": "Dërgo raportin",
    "SUBMITTING": "Duke dërguar...",
    "CANCEL": "Anulo",
    "SUCCESS": "Raporti i defektit u dërgua me sukses. Faleminderit!",
    "VALIDATION_ERROR": "Përshkruani problemin para se ta dërgoni"
  },
  "APP_GLOBAL": {
    "TRIAL_MESSAGE": "days trial remaining.",
    "TRAIL_BUTTON": "Buy Now",
    "DELETED_USER": "Deleted User",
    "EMAIL_VERIFICATION_PENDING": "It seems that you haven't verified your email address yet. Please check your inbox for the verification email.",
    "RESEND_VERIFICATION_MAIL": "Resend verification email",
    "EMAIL_VERIFICATION_SENT": "Verification email has been sent. Please check your inbox.",
    "ACCOUNT_SUSPENDED": {
      "TITLE": "Account Suspended",
      "MESSAGE": "Your account is suspended. Please reach out to the support team for more information."
    }
  },
  "COMPONENTS": {
    "CODE": {
      "BUTTON_TEXT": "Copy",
      "CODEPEN": "Open in CodePen",
      "COPY_SUCCESSFUL": "Copied to clipboard"
    },
    "SHOW_MORE_BLOCK": {
      "SHOW_MORE": "Show More",
      "SHOW_LESS": "Show Less"
    },
    "FILE_BUBBLE": {
      "DOWNLOAD": "Download",
      "UPLOADING": "Po ngarkohet...",
      "INSTAGRAM_STORY_UNAVAILABLE": "This story is no longer available.",
      "RECORDING_UNAVAILABLE": "Ky regjistrim nuk është më i disponueshëm.",
      "DELETE_RECORDING": {
        "BUTTON": "Fshi regjistrimin e thirrjes",
        "TITLE": "Të fshihet regjistrimi i thirrjes?",
        "DESCRIPTION": "Të gjitha regjistrimet e kësaj thirrjeje do të fshihen përgjithmonë nga centrali telefonik dhe nuk mund të rikthehen. Transkriptimi dhe përmbledhja e thirrjes mbeten.",
        "CONFIRM": "Fshi",
        "SUCCESS": "Regjistrimi i thirrjes u fshi",
        "ERROR": "Regjistrimi i thirrjes nuk u fshi dot. Provo përsëri."
      }
    },
    "LOCATION_BUBBLE": {
      "SEE_ON_MAP": "See on map"
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Submit"
    },
    "MEDIA": {
      "IMAGE_UNAVAILABLE": "This image is no longer available.",
      "LOADING_FAILED": "Loading failed"
    }
  },
  "CONFIRM_EMAIL": "Verifying...",
  "SETTINGS": {
    "INBOXES": {
      "NEW_INBOX": "Add Inbox"
    }
  },
  "SIDEBAR": {
    "NO_ITEMS": "No items",
    "CURRENTLY_VIEWING_ACCOUNT": "Currently viewing:",
    "SWITCH": "Switch",
    "INBOX_VIEW": "Inbox View",
    "CONVERSATIONS": "Conversations",
    "INBOX": "My Inbox",
    "ALL_CONVERSATIONS": "All Conversations",
    "MENTIONED_CONVERSATIONS": "Mentions",
    "PARTICIPATING_CONVERSATIONS": "Participating",
    "UNATTENDED_CONVERSATIONS": "Unattended",
    "REPORTS": "Reports",
    "SETTINGS": "Settings",
    "CONTACTS": "Contacts",
    "DATA_ASSISTANT": "Asistenti i të dhënave",
    "CAPTAIN": "Captain",
    "CAPTAIN_ASSISTANTS": "Assistants",
    "CAPTAIN_DOCUMENTS": "Documents",
    "CAPTAIN_RESPONSES": "FAQs",
    "HOME": "Home",
    "AGENTS": "Agents",
    "AGENT_BOTS": "Bots",
    "AUDIT_LOGS": "Audit Logs",
    "WHATSAPP_TEMPLATES": "Shabllonet e WhatsApp",
    "BLOCKED_DOMAINS": "SPAM",
    "INBOXES": "Inboxes",
    "NOTIFICATIONS": "Notifications",
    "CANNED_RESPONSES": "Canned Responses",
    "INTEGRATIONS": "Integrations",
    "PROFILE_SETTINGS": "Profile Settings",
    "ACCOUNT_SETTINGS": "Account Settings",
    "APPLICATIONS": "Applications",
    "LABELS": "Labels",
    "CUSTOM_ATTRIBUTES": "Custom Attributes",
    "AUTOMATION": "Automation",
    "MACROS": "Macros",
    "TEAMS": "Teams",
    "BILLING": "Billing",
    "CUSTOM_VIEWS_FOLDER": "Folders",
    "CUSTOM_VIEWS_SEGMENTS": "Segments",
    "ALL_CONTACTS": "All Contacts",
    "TAGGED_WITH": "Tagged with",
    "NEW_LABEL": "New label",
    "NEW_TEAM": "New team",
    "NEW_INBOX": "New inbox",
    "REPORTS_CONVERSATION": "Conversations",
    "CSAT": "CSAT",
    "LIVE_CHAT": "Live Chat",
    "SMS": "SMS",
    "CAMPAIGNS": "Campaigns",
    "ONGOING": "Ongoing",
    "ONE_OFF": "One off",
    "REPORTS_SLA": "SLA",
    "REPORTS_BOT": "Bot",
    "REPORTS_AGENT": "Agents",
    "REPORTS_LABEL": "Labels",
    "REPORTS_INBOX": "Inbox",
    "REPORTS_TEAM": "Team",
    "REPORTS_PHONE": "Telefoni",
    "WALLBOARD": "Wallboard",
    "WALLBOARD_OVERVIEW": "Përmbledhje",
    "WALLBOARD_QUEUES": "Radhët",
    "DATA_ASSISTANT_CHAT": "Chat",
    "DATA_ASSISTANT_REPORTS": "Raportet",
    "NO_WAITING_CALLERS": "asnjë telefonues në pritje",
    "WAITING_CALLERS": "{count} telefonues në pritje",
    "SET_AVAILABILITY_TITLE": "Set yourself as",
    "SET_YOUR_AVAILABILITY": "Set your availability",
    "AVAILABILITY_IMPERSONATING": "I kyçur ndërsa jeni identifikuar si ky përdorues",
    "SLA": "SLA",
    "CUSTOM_ROLES": "Custom Roles",
    "NEW_CONVERSATION": "Bisedë e re",
    "DRAFT": "Draft",
    "BETA": "Beta",
    "REPORTS_OVERVIEW": "Overview",
    "REAUTHORIZE": "Your inbox connection has expired, please reconnect\n to continue receiving and sending messages",
    "HELP_CENTER": {
      "TITLE": "Help Center",
      "ARTICLES": "Articles",
      "CATEGORIES": "Categories",
      "LOCALES": "Locales",
      "SETTINGS": "Settings",
      "DICTIONARY": "Fjalori"
    },
    "CHANNELS": "Channels",
    "SET_AUTO_OFFLINE": {
      "TEXT": "Mark offline automatically",
      "INFO_TEXT": "Let the system automatically mark you offline when you aren't using the app or dashboard.",
      "INFO_SHORT": "Automatically mark offline when you aren't using the app."
    },
    "DOCS": "Read docs"
  },
  "BLOCKED_DOMAINS_SETTINGS": {
    "HEADER": "Domenet dhe kontaktet e bllokuara",
    "DESCRIPTION": "Lista e domeneve të email-it të bllokuara për këtë llogari.",
    "NO_BLOCKED_DOMAINS": "Nuk u gjetën domene të bllokuara.",
    "BLOCKED_CONTACTS_BTN": "Kontaktet e bllokuara"
  },
  "BILLING_SETTINGS": {
    "TITLE": "Billing",
    "DESCRIPTION": "Manage your subscription here, upgrade your plan and get more for your team.",
    "CURRENT_PLAN": {
      "TITLE": "Current Plan",
      "PLAN_NOTE": "You are currently subscribed to the **{plan}** plan with **{quantity}** licenses",
      "SEAT_COUNT": "Number of seats",
      "RENEWS_ON": "Renews on"
    },
    "VIEW_PRICING": "View Pricing",
    "MANAGE_SUBSCRIPTION": {
      "TITLE": "Manage your subscription",
      "DESCRIPTION": "View your previous invoices, edit your billing details, or cancel your subscription.",
      "BUTTON_TXT": "Go to the billing portal"
    },
    "CAPTAIN": {
      "TITLE": "Captain",
      "DESCRIPTION": "Manage usage and credits for Captain AI.",
      "BUTTON_TXT": "Buy more credits",
      "DOCUMENTS": "Documents",
      "RESPONSES": "Responses",
      "UPGRADE": "Captain is not available on the free plan, upgrade now to get access to assistants, copilot and more."
    },
    "CHAT_WITH_US": {
      "TITLE": "Need help?",
      "DESCRIPTION": "Do you face any issues in billing? We are here to help.",
      "BUTTON_TXT": "Chat with us"
    },
    "NO_BILLING_USER": "Your billing account is being configured. Please refresh the page and try again."
  },
  "CREATE_ACCOUNT": {
    "NO_ACCOUNT_WARNING": "Oh! Nuk gjetëm asnjë llogari. Krijoni një llogari të re për të vazhduar.",
    "NEW_ACCOUNT": "New Account",
    "SELECTOR_SUBTITLE": "Create a new account",
    "API": {
      "SUCCESS_MESSAGE": "Account created successfully",
      "EXIST_MESSAGE": "Account already exists",
      "ERROR_MESSAGE": "Could not connect to chat server, Please try again later"
    },
    "FORM": {
      "NAME": {
        "LABEL": "Company Name",
        "PLACEHOLDER": "Wayne Enterprises"
      },
      "SUBMIT": "Submit",
      "CANCEL": "Anulo"
    }
  },
  "KEYBOARD_SHORTCUTS": {
    "TOGGLE_MODAL": "View all shortcuts",
    "TITLE": {
      "OPEN_CONVERSATION": "Open conversation",
      "RESOLVE_AND_NEXT": "Resolve and move to next",
      "NAVIGATE_DROPDOWN": "Navigate dropdown items",
      "RESOLVE_CONVERSATION": "Resolve Conversation",
      "GO_TO_CONVERSATION_DASHBOARD": "Go to Conversation Dashboard",
      "ADD_ATTACHMENT": "Add Attachment",
      "GO_TO_CONTACTS_DASHBOARD": "Go to Contacts Dashboard",
      "TOGGLE_SIDEBAR": "Toggle Sidebar",
      "GO_TO_REPORTS_SIDEBAR": "Go to Reports sidebar",
      "MOVE_TO_NEXT_TAB": "Move to next tab in conversation list",
      "GO_TO_SETTINGS": "Go to Settings",
      "SWITCH_TO_PRIVATE_NOTE": "Switch to Private Note",
      "SWITCH_TO_REPLY": "Switch to Reply",
      "TOGGLE_SNOOZE_DROPDOWN": "Toggle snooze dropdown",
      "AI_ASSIST_MENU": "Ndihma IA",
      "AI_ASSIST_GRAMMAR": "Korrigjo gramatikën",
      "AI_ASSIST_UNIFY_LANG": "Njësoje gjuhën e mesazhit"
    }
  }
}
